exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bindEmailAccountView .inputBox .el-form {\n  width: 100%;\n  height: 100%;\n}\n.bindEmailAccountView .inputBox .el-form .el-form-item {\n  height: 100%;\n  width: 100%;\n}\n.bindEmailAccountView .inputBox .el-form .el-form-item .el-form-item__content {\n  height: 100%;\n  width: 100%;\n}\n", ""]);

// exports
